import {
    LoginRequest,
    clearCookies,
    getProfileLocal,
    getUserLocal,
    goToProfile,
    setProfileLocal,
    setUserLocal,
} from "../utils/common";
import React, { createContext, useEffect } from "react";

import Cookies from "universal-cookie";
import { api } from "../services/api";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

function usePrevious(value) {
    const ref = React.useRef();
    React.useEffect(() => {
        ref.current = value;
    }, [value]);

    return ref.current;
}

const DEFAULT_VALUE = {
    franchise: {
        id: -1,
        name: "",
        type: -1,
        nickname: "",
        roles: [
            {
                id: -1,
                name: "",
                perfil_name: "",
            },
        ],
    },
    profile: false,
    setProfile: () => {},
    login: () => {},
    logout: () => {},
    forgot: () => {},
    token: () => {},
    changePassword: () => {},
    loading: false,
    isAuth: false,
};

export const UserContext = createContext(DEFAULT_VALUE);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = React.useState(getUserLocal());
    const [profile, setProfile] = React.useState(getProfileLocal());

    const [loading, setLoading] = React.useState(false);

    const navigate = useNavigate();

    const logout = async () => {
        setLoading(true);
        try {
            await api.post("/logout");
        } catch (error) {
            console.log(error);
        } finally {
            setProfile(false);
            setProfileLocal(false);
            setUser(false);
            setUserLocal(false);

            new Promise((resolve, reject) => {
                resolve(clearCookies());
            }).then(() => {});

            setLoading(false);
        }
    };

    const login = async (email, password) => {
        setLoading(true);
        try {
            let res = await LoginRequest(email, password);

            if (!res) return;

            res = res?.filter((franchise) => {
                return (
                    franchise.roles.filter((role) => {
                        return role.is_panel;
                    }).length > 0
                );
            });

            res = res.map((franchise) => {
                return {
                    ...franchise,
                    roles: franchise.roles.filter((role) => {
                        return role.is_panel;
                    }),
                };
            });

            console.log(res);

            const actual_profile = res[0]?.roles[0];
            const selectedFranchise = res[0];

            if (res.length === 0) {
                message.error(
                    "Você não tem permissão para acessar essa área"
                );
                return;
            }

            const data = await goToProfile({
                franchise_hash: selectedFranchise?.hash,
                role_id: actual_profile?.id,
            });

            if (!data) {
                message.error("Erro ao carregar perfil");
                await logout();
                return;
            }

            setProfile({
                ...selectedFranchise,
                ...data,
                role_id: actual_profile?.id,
            });

            setProfileLocal({
                ...selectedFranchise,
                ...data,
                role_id: actual_profile?.id,
            });

            navigate("/");

            setUser(res);
            setUserLocal(res);

            return res;
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const forgot = async (email) => {
        setLoading(true);
        try {
            await api.get("/sanctum/csrf-cookie");
            try {
                await api.post("/forgot-password", { email });
                return true;
            } catch (error) {
                return false;
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const token = async (email, token) => {
        setLoading(true);
        try {
            await api.post("/validate-token", { email, token });
            return true;
        } catch (error) {
            return false;
        } finally {
            setLoading(false);
        }
    };

    const changePassword = async (email, token, password, password_confirmation) => {
        setLoading(true);
        try {
            await api.post("/reset-password", {
                email,
                token,
                password,
                password_confirmation,
            });
            return true;
        } catch (error) {
            return false;
        } finally {
            setLoading(false);
        }
    };

    return (
        <UserContext.Provider
            value={{
                login,
                logout,
                forgot,
                token,
                changePassword,
                user,
                setUser,
                setUserLocal,
                profile,
                loading,
                setProfile,
            }}
        >
            {children}
        </UserContext.Provider>
    );
};
